module.exports = __webpack_public_path__ + "static/img/news.6df1683.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/news.png
// module id = WjwN
// module chunks = 0